module.exports = __webpack_public_path__ + "static/img/target.8bfce5ed.svg";